export default {
  'otp:title': 'SMS-тегі кодты жазыңыз',
  'otp:text': '<span class="marked inline-flex mb-1">Балаңыздың</span> {0} телефон нөміріне растау коды жазылған SMS жолданды.',
  'otp:timer': '<span class="otp__timer-counter">{0}</span> секундтан кейін қайта жолдау',
  'otp:btn': 'Қайта жолдау'
}
